import { getSSCID, sscidListener, getBaseURL } from '@rei/sscid-listener';
import { optoutListener } from '@rei/optout-listener';
import { GPC_LOCAL_STORAGE_KEY, SUCCESFUL_OPTOUT_STATUS } from './app-config';

export const hasAlreadyOptedOut = () => {
  const optOutCode = localStorage.getItem(GPC_LOCAL_STORAGE_KEY);
  return !!(optOutCode === SUCCESFUL_OPTOUT_STATUS);
};

export const storeOptOutStatus = (status) => {
  localStorage.setItem(GPC_LOCAL_STORAGE_KEY, status);
};

export const isSupportedDomain = (domain) => {
  if (domain === 'localhost') return false;

  const domainParts = domain.split('.');
  const domainBase = domainParts[domainParts.length - 2];
  return !!(domainBase === 'rei' || domainBase === 'rei-cloud');
};

export const gpcListener = async () => {
  // Check for opt-out from another session
  optoutListener();

  // Handle logged-in user payload
  sscidListener();

  // Don't make the request if already opted out
  if (hasAlreadyOptedOut()) return false;

  let gpcValue = navigator.globalPrivacyControl || false;
  const sscid = getSSCID();

  if (gpcValue && sscid) {
    const endpointUrl = `${getBaseURL()}/gpc/signals/ciam`;
    const response = await fetch(endpointUrl, {
      method: 'POST',
      priority: 'low',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sscid }),
    });
    if (!response.ok) {
      gpcValue = false;
    }
    storeOptOutStatus(response.status);
  }
  return gpcValue;
};

export default {
  isSupportedDomain,
};
